import React from 'react';
import PropTypes from 'prop-types';

import { Container, Accordion, Title } from '@mantine/core';

import * as classes from './Faq.module.css';


function Faq({ faqList, faqTitolo }) {
  return (
    <Container className={classes.wrapper}>
      <Title order={3} ta="center" className={classes.title}>{faqTitolo}</Title>
      <Accordion variant="separated" mt="xl">
        {faqList.map(({ faqDomanda, faqRisposta }, key) => (
          <Accordion.Item className={classes.item} value={`faq_${key}`} key={`faq_${key + 1}`}>
            <Accordion.Control>{faqDomanda}</Accordion.Control>
            <Accordion.Panel>
              <div dangerouslySetInnerHTML={{ __html: faqRisposta }} />
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>
  );
}

Faq.propTypes = {
  faqList: PropTypes.array,
  faqTitolo: PropTypes.string,
};

export default Faq;
